import { Button, Checkbox, Input, Label, Select, Textarea } from '@/components'
import React, { useEffect, useRef, useState } from 'react'
import { options } from '../boardItem'
import { useResponsive } from '@/hooks/useResponsive'

// Props 타입 정의
interface InsertFormProps {
  formData: {
    bbsSj: string
    nttSj: string
    nttCn: string
    guestName?: string
    guestEml?: string
    guestTermAgree?: boolean
  }
  fileName?: string | undefined
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  handleChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => void
  handleCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleFileChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleButtonClick: () => void
  handleList: () => void
  openPrivacyPolicy?: () => void
  showPolicyPopup?: boolean
  setShowPolicyPopup?: React.Dispatch<React.SetStateAction<boolean>>
  navigate: (path: string) => void
  isAuthenticated: boolean
  insertBoard?: () => void
}

export const InquriyInsertForm: React.FC<InsertFormProps> = ({
  formData,
  handleSubmit,
  handleChange,
  handleCheckboxChange,
  handleList,
  openPrivacyPolicy,
  isAuthenticated,
}) => {
  const { isMobile, isTablet, isDesktop } = useResponsive()
  return (
    <>
      {!isMobile ? (
        <form onSubmit={handleSubmit}>
          <div
            style={{
              marginBottom: '10px',
              display: 'flex',
              gap: '5px',
            }}
          >
            <Select
              id="bbsSj"
              name="bbsSj"
              width="200px"
              value={formData.bbsSj}
              onChange={handleChange}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
            <Input
              id="nttSj"
              name="nttSj"
              placeholder="제목을 입력하세요."
              maxLength={255}
              value={formData.nttSj}
              onChange={handleChange}
            />
          </div>
          <div
            style={{
              marginBottom: '10px',
            }}
          >
            <Textarea
              id="nttCn"
              name="nttCn"
              width={'100%'}
              height={'500px'}
              placeholder="내용을 입력하세요."
              state="success"
              value={formData.nttCn}
              onChange={handleChange}
            />
          </div>
          {!isAuthenticated && (
            <>
              <div
                style={{
                  marginBottom: '10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'stretch',
                  gap: '5px',
                }}
              >
                <div style={{ flex: 1 }}>
                  <Label display="block" mb="5px" htmlFor="guestName">
                    <span style={{ color: 'orange' }}>*&nbsp;</span>작성자
                  </Label>
                  <div style={{ marginTop: '5px' }} />
                  <Input
                    id="guestName"
                    name="guestName"
                    width="100%"
                    placeholder="10자 이내로 입력 (한글,영어만 가능)"
                    maxLength={10}
                    value={formData.guestName}
                    onChange={handleChange}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Label display="block" mb="5px" htmlFor="guestEml">
                    <span style={{ color: 'orange' }}>*&nbsp;</span>이메일
                  </Label>
                  <div style={{ marginTop: '5px' }} />
                  <Input
                    id="guestEml"
                    name="guestEml"
                    width="100%"
                    placeholder="입력 예시 : example@example.com"
                    maxLength={30}
                    value={formData.guestEml}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
              >
                <div style={{ display: 'flex', gap: '5px', marginTop: '10px' }}>
                  <Checkbox
                    id="guestTermAgree"
                    name="guestTermAgree"
                    label="[필수] 개인정보 수집 및 이용 동의"
                    checked={formData.guestTermAgree}
                    onChange={handleCheckboxChange}
                  />
                  <div
                    onClick={openPrivacyPolicy}
                    style={{
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      color: '#d09d30',
                    }}
                  >
                    내용보기
                  </div>
                </div>
              </div>
            </>
          )}
          {/* {isAuthenticated && (
        <InsertFile
          fileInputRef={fileInputRef}
          handleFileChange={handleFileChange}
          fileName={fileName}
          handleButtonClick={handleButtonClick}
        />
      )} */}
          {/* <FileUploadSample /> */}
          <div
            style={{
              marginBottom: '10px',
            }}
          ></div>
          <div style={{ display: 'flex' }}>
            <div style={{ marginLeft: 'auto' }}>
              <div style={{ display: 'flex', gap: '5px' }}>
                <Button color="neverbe" type="submit">
                  저장
                </Button>
                <Button color="neverbe" onClick={handleList}>
                  취소
                </Button>
              </div>
            </div>
          </div>
        </form>
      ) : (
        <div className="mobile-write-container">
          <div className="mobile-write-header">
            <h1 className="mobile-write-title">문의</h1>
            <button className="mobile-back-btn" onClick={handleList}>
              ← 뒤로
            </button>
          </div>

          <div className="mobile-write-card">
            <form className="mobile-write-form" onSubmit={handleSubmit}>
              <div className="mobile-form-row">
                <div className="mobile-form-group category">
                  <label className="mobile-form-label">카테고리</label>
                  <select
                    className="mobile-form-select"
                    id="bbsSj"
                    name="bbsSj"
                    value={formData.bbsSj}
                    onChange={handleChange}
                    required
                  >
                    {options.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mobile-form-group title">
                  <label className="mobile-form-label">제목</label>
                  <input
                    type="text"
                    className="mobile-form-input"
                    id="nttSj"
                    name="nttSj"
                    placeholder="제목을 입력하세요"
                    value={formData.nttSj}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {!isAuthenticated && (
                <div className="mobile-author-row">
                  <div className="mobile-form-group">
                    <label className="mobile-form-label">작성자</label>
                    <input
                      type="text"
                      className="mobile-form-input"
                      id="guestName"
                      name="guestName"
                      width="100%"
                      placeholder="10자 이내로 입력 (한글,영어만 가능)"
                      maxLength={10}
                      value={formData.guestName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mobile-form-group">
                    <label className="mobile-form-label">이메일</label>
                    <input
                      type="email"
                      className="mobile-form-input"
                      id="guestEml"
                      name="guestEml"
                      value={formData.guestEml}
                      onChange={handleChange}
                      placeholder="입력 예시 : example@example.com"
                    />
                  </div>
                </div>
              )}

              <div className="mobile-form-group">
                <label className="mobile-form-label">내용</label>
                <textarea
                  className="mobile-form-textarea"
                  id="nttCn"
                  name="nttCn"
                  value={formData.nttCn}
                  placeholder="내용을 입력하세요"
                  onChange={handleChange}
                />
              </div>
              {!isAuthenticated && (
                <div className="mobile-form-checkbox">
                  <input
                    type="checkbox"
                    id="guestTermAgree"
                    name="guestTermAgree"
                    checked={formData.guestTermAgree} // 문자열을 boolean으로 변환
                    onChange={handleCheckboxChange}
                  />
                  <label
                    htmlFor="guestTermAgree"
                    className="mobile-checkbox-label"
                  >
                    [필수] 개인정보 수집 및 이용 동의&nbsp;
                    <span
                      className="mobile-checkbox-link"
                      onClick={(e) => {
                        openPrivacyPolicy?.()
                      }}
                    >
                      내용보기
                    </span>
                  </label>
                </div>
              )}
              {/* <div className="mobile-file-upload">
                <input type="file" id="file-input" multiple />

                <label for="file-input" class="mobile-file-upload-label">
                  📎 파일 첨부
                </label>
                <div style="margin-top: 8px; font-size: 12px; color: #999;">
                  최대 5MB, 이미지/문서 파일만 가능
                </div>
              </div> */}
              <div className="mobile-post-actions">
                <button type="submit" className="mobile-action-btn primary">
                  저장
                </button>
                <>
                  <button
                    type="submit"
                    className="mobile-action-btn user"
                    onClick={handleList}
                  >
                    취소
                  </button>
                </>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
